{
  "version": "1.2.6",
  "objects": {
    "7536295120974152361": {
      "type": "frame",
      "id": "7536295120974152361",
      "z": 11687,
      "textContent": "",
      "left": 3524.5439547686287,
      "top": 1216.5679833992397,
      "width": 1110,
      "height": 625,
      "scaleX": 0.20512918907858244,
      "scaleY": 0.25128328373471015,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a391u",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120977038773": {
      "type": "frame",
      "id": "7536295120977038773",
      "z": 9689,
      "textContent": "",
      "left": 3544.5439547686287,
      "top": 1292.9041060907157,
      "width": 1110,
      "height": 625,
      "scaleX": 0.1690931530425464,
      "scaleY": 0.0971454874283485,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7536295120974152361",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a18KT",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295120974274336": {
      "type": "shape",
      "id": "7536295120974274336",
      "z": 9693,
      "shapeName": "text",
      "textContent": "<p><strong>2.5 hours</strong></p>",
      "left": 3544.5439547686287,
      "top": 1292.9041060907157,
      "width": 72.1,
      "height": 29.4,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.4285714285714286,
      "scaleY": 1.4285714285714286,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 20,
      "angle": 0,
      "container": "7536295120977038773",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a08wm",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120978864286": {
      "type": "shape",
      "id": "7536295120978864286",
      "z": 9694,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#16A468\">up 2.5%</span><span style=\"color:#B6B6B6\"> over last 7 days</span></p>",
      "left": 3544.5439547686287,
      "top": 1323.6200357334335,
      "width": 163,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7536295120977038773",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1Am0",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120971892714": {
      "type": "frame",
      "id": "7536295120971892714",
      "z": 9690,
      "textContent": "",
      "left": 3544.5439547686287,
      "top": 1236.5679833992397,
      "width": 1110,
      "height": 625,
      "scaleX": 0.1690931530425464,
      "scaleY": 0.057333929684784166,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7536295120974152361",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a07Ch",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120984029793": {
      "type": "frame",
      "id": "7536295120984029793",
      "z": 9691,
      "textContent": "",
      "left": 3696.4036485928646,
      "top": 1236.5679833992397,
      "width": 1110,
      "height": 625,
      "scaleX": 0.0322826180657572,
      "scaleY": 0.05733392968478416,
      "fill": "#16A468",
      "opacity": 0.1,
      "container": "7536295120971892714",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1ALf",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120981621585": {
      "type": "shape",
      "id": "7536295120981621585",
      "z": 9695,
      "shapeName": "icon",
      "textContent": "",
      "left": 3703.366252872724,
      "top": 1242.5305876790987,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.21908497493271795,
      "scaleY": 0.21908497493271795,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#16A468",
      "angle": 0,
      "container": "7536295120984029793",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a08gR",
      "maskType": "none",
      "iconName": "fas/clock",
      "locked": false
    },
    "7536295120983980573": {
      "type": "shape",
      "id": "7536295120983980573",
      "z": 9692,
      "shapeName": "text",
      "textContent": "<p><strong>Title</strong></p>",
      "left": 3544.5439547686287,
      "top": 1239.4848364257348,
      "width": 39,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7536295120971892714",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a00Y7",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
